import React from "react";
import { useApi } from "../../../../hooks/useApi";

// Goal count + tracked hours for the projects currently on screen.
//
// One request per page of rows, not one per row: the backend
// (GET /api/v1/projects/stats-summary) does the two aggregates and returns a
// { [projectId]: { goals, hours, sessions } } map. Counts are all-time; the
// panels do their own date-range filtering.
export function useProjectStats(projectIds) {
  const api = useApi();
  const [stats, setStats] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  // Depend on the joined key, not the array identity, or every list re-render
  // would refetch.
  const key = React.useMemo(() => (projectIds || []).filter(Boolean).join(","), [projectIds]);

  React.useEffect(() => {
    if (!key) { setStats({}); return; }
    let alive = true;
    setLoading(true);
    (async () => {
      try {
        const res = await api.get(`/api/v1/projects/stats-summary?ids=${encodeURIComponent(key)}`);
        if (alive) setStats(res.data?.data?.stats || {});
      } catch (_) {
        // Counts are decorative — a failure shows "—", it never blocks the list.
        if (alive) setStats({});
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [api, key]);

  return { stats, loading };
}
